import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-hexagon-edges-svg',
  standalone: true,
  template: `
    <svg viewBox="0 0 201 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g style="mix-blend-mode:plus-lighter">
        <line x1="6.25" y1="70.8243" x2="88.102" y2="23.567" [attr.stroke]="colorWithOpacity()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter0_f_hex_edges)">
        <line x1="6.25" y1="70.8243" x2="88.102" y2="23.567" [attr.stroke]="color()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <line x1="88.1021" y1="256.319" x2="6.25005" y2="209.062" [attr.stroke]="colorWithOpacity()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter1_f_hex_edges)">
        <line x1="88.1021" y1="256.319" x2="6.25005" y2="209.062" [attr.stroke]="color()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <line x1="194.602" y1="209.433" x2="112.75" y2="256.69" [attr.stroke]="colorWithOpacity()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter2_f_hex_edges)">
        <line x1="194.602" y1="209.433" x2="112.75" y2="256.69" [attr.stroke]="color()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <line x1="112.75" y1="23.1956" x2="194.602" y2="70.4529" [attr.stroke]="colorWithOpacity()"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter3_f_hex_edges)">
        <line x1="112.75" y1="23.1956" x2="194.602" y2="70.4529" [attr.stroke]="color()"/>
      </g>
      <defs>
        <filter id="filter0_f_hex_edges" x="0" y="17.134" width="94.352" height="60.1233" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter1_f_hex_edges" x="6.10352e-05" y="202.629" width="94.352" height="60.1233"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter2_f_hex_edges" x="106.5" y="203" width="94.352" height="60.1233" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter3_f_hex_edges" x="106.5" y="16.7626" width="94.352" height="60.1233" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur"/>
        </filter>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HexagonEdgesSvgComponent {
  readonly color = input.required<string>();
  readonly colorWithOpacity = input.required<string>();
}
